export enum ViewMode {
  TAB = 'TAB',
  LIST = 'LIST',
  LOADING = 'LOADING'
}
